"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _Function = _interopRequireDefault(require("./Function.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var shouldAlternateColors = function shouldAlternateColors(path) {
  return R.filter(R.equals('arguments'), path).length % 2 !== 0;
};
var Function = function Function(_ref) {
  var renderMember = _ref.renderMember,
    keysPath = _ref.keysPath,
    args = _ref.args,
    value = _ref.value,
    separator = _ref.separator,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement(_Function["default"], {
    className: "formula-group",
    alternate: shouldAlternateColors(keysPath),
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-group-operator"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-operator-label"
  }, (0, _utils.toUpper)(value))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-group-elements"
  }, /* eslint-disable */
  args.map(function (arg, index) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "function-arg-".concat(index)
    }, arg.map(function (item, innerIndex) {
      return renderMember({
        keysPath: [].concat(_toConsumableArray(keysPath), ['arguments', index, innerIndex]),
        member: item,
        key: R.prop('key', item)
      });
    }), index < args.length - 1 && separator());
  })
  /* eslint-enable */));
};

Function.defaultProps = {
  separator: function separator() {
    return /*#__PURE__*/_react["default"].createElement("strong", {
      className: "formula-comma"
    }, ",");
  },
  disabled: false
};
Function.propTypes = {
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired,
  renderMember: _propTypes["default"].func.isRequired,
  separator: _propTypes["default"].func,
  args: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    type: _propTypes["default"].string,
    displayName: _propTypes["default"].string
  }))).isRequired,
  keysPath: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])).isRequired
};
Function.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Function",
  "props": {
    "separator": {
      "defaultValue": {
        "value": "() => <strong className=\"formula-comma\">,</strong>",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "value": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "renderMember": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "args": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "value": {
                "name": "string",
                "required": false
              },
              "type": {
                "name": "string",
                "required": false
              },
              "displayName": {
                "name": "string",
                "required": false
              }
            }
          }
        }
      },
      "required": true
    },
    "keysPath": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": true
    }
  }
};
var _default = Function;
exports["default"] = _default;